export default __webpack_public_path__ + "static/media/band6.8025dec0.jfif";